import React, { useState } from "react";
import { TableHeader } from "@services/ui-components";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import CreateUpdateClientForm from "../CreateClient/CreateUpdateClientForm";
import Spinner from "@services/ui-components/src/Spinner/Spinner";
import { ApolloError, useReactiveVar } from "@apollo/client";
import { ErrorModalComponent } from "@me-pos/error-modal";
import i18next from "i18next";
import ErrorService from "../../services/ErrorService";
import { useGetOneClientQuery } from "@me-team/host/main/clients/graphql/clients.hooks";
import { CompanyAccess } from "@me-team/host/main/graphql/types";
import { currentCompanyIdVar } from "@me-team/host/main/globalVar/state";
import { useRoleAccess } from "@me-team/host/src/utils/useRoleAccess";

const UpdateClient: React.FC = () => {
    const { t } = useTranslation();
    const { branchId, id } = useParams();
    const currentCompanyId = useReactiveVar(currentCompanyIdVar);
    const canEditClient = useRoleAccess(CompanyAccess.ClientEdit);
    const shouldShowClientContacts = useRoleAccess(CompanyAccess.ClientsShowContacts);
    const isFormReadOnly = !canEditClient;
    const [isErrorModalOpen, setIsErrorModalOpen] = useState<number>(null);

    const { data: oneClientData, loading } = useGetOneClientQuery({
        variables: {
            id: +id,
            companyId: +currentCompanyId,
            branchId: Number(branchId),
        },
        skip: !currentCompanyId || !id,
        context: {
            errorType: "global",
        },
        onError: (error: ApolloError) => {
            setIsErrorModalOpen(ErrorService.errorHandling(error));
        },
    });

    const client = oneClientData?.user?.company?.clients?.clients[0];

    if (loading) return <Spinner />;
    return (
        <div className="mb-3">
            <TableHeader
                title={`${t("Editing")} ${client?.name}`}
                paths={[
                    { path: `/clients/${currentCompanyId}/list/${id}/edit/${branchId}`, label: t("Customers") },
                    { path: `/clients/${currentCompanyId}/list/${branchId}`, label: t("List of Clients") },
                    {
                        path: `/clients/${currentCompanyId}/list/${id}/edit/${branchId}`,
                        label: `${t("Editing")} ${client?.name}`,
                    },
                ]}
                colSize={12}
            />
            <CreateUpdateClientForm
                isFormReadOnly={isFormReadOnly}
                shouldShowClientContacts={shouldShowClientContacts}
            />
            {isErrorModalOpen ? (
                <ErrorModalComponent
                    i18n={i18next}
                    onClose={() => {
                        setIsErrorModalOpen(null);
                    }}
                    isOpen={!!isErrorModalOpen}
                    currentError={isErrorModalOpen}
                />
            ) : null}
        </div>
    );
};

export default UpdateClient;
